import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/integrations/supabase/client'

/**
 * Fetches fixture exclusions for a league+season.
 * Returns a Set of excluded fixture IDs for fast lookups.
 */
export function useFixtureExclusions(leagueId?: string, season?: string) {
  const query = useQuery({
    queryKey: ['fixture-exclusions', leagueId, season],
    enabled: !!leagueId && !!season,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('fixture_exclusions')
        .select('fixture_id, matchday, reason, id, created_at')
        .eq('league_id', leagueId!)
        .eq('season', season!)

      if (error) {
        console.error('Error fetching fixture exclusions:', error)
        throw error
      }

      return data || []
    },
    staleTime: 30 * 1000,
  })

  const excludedFixtureIds = new Set(
    (query.data || []).map((row) => row.fixture_id)
  )

  return {
    ...query,
    excludedFixtureIds,
    exclusions: query.data || [],
  }
}
